module.exports = "//static.hsappstatic.net/salesImages/static-1.403/icons/outlook-2015.png"